import dayjs from "dayjs";

export const getPageDetails = (results = []) => {
  if (!results?.length) return [];

  const formattedPageData = results.map((page) => {
    const plainLastModified = page?.lastModified;
    const plainCreatedAt = page?.content?.history?.createdDate;

    const lastModified = dayjs(plainLastModified).set("second", 0);
    const createdAt = dayjs(plainCreatedAt).set("second", 0);
    const status =
      createdAt.diff(lastModified, "minute") >= 0 ? "Created" : "Updated";

    const plainUserData =
      status === "Created"
        ? page.content.history.createdBy
        : page.content.history.lastUpdated.by;

    const isValidDate = dayjs(page.friendlyLastModified).isValid();
    const friendlyModified = isValidDate
      ? dayjs(page.friendlyLastModified).format("MMM D, YYYY")
      : page.friendlyLastModified;

    return {
      id: page.content.id,
      friendlyModified,
      status,
      type: page.content.type === "page" ? "page" : "blog",
      accountId: plainUserData.accountId,
      name: plainUserData.displayName,
      avatarUrl: `${window.AP._hostOrigin}${plainUserData.profilePicture.path}`,
      linkToPage: `${window.AP._hostOrigin}/wiki${page.content._links.tinyui}`,
    };
  });

  if (formattedPageData?.length) {
    return formattedPageData.filter(
      (pageData, index) =>
        formattedPageData.findIndex(
          (item) => item.accountId === pageData.accountId
        ) === index
    );
  }

  return [];
};

export const fetchRecentContent = () => {
  const cql = `type in (page, blogpost) order by created desc, lastmodified desc&expand=content.history.lastUpdated`;
  return window.AP.request(`/rest/api/search?cql=${cql}`);
};
